module.exports = __webpack_public_path__ + "static/media/55837779_590686261417994_1531380682561945600_o.dd40ce92.jpg";